export default {
	UPDATE_PAGE( state, page ) {
		state.page = page;
	}
};